module.exports = __webpack_public_path__ + "img/shop-photo11.a9eb5766.jpg";